class EqualOps {
  constructor({ 
    preferNotDateOfBirth,
    dateOfBirth,
    
    selectedGenderId,
    selectedRaceId,
    sexualOrientationId,
    selectedFaithId,
    selectedDisabledStatus,
    
    genderSelfDescription,
    raceSelfDescription,
    orientationSelfDescription,
    faithSelfDescription,

    preferNotNationality,
    nationalitySelfDescription,
    selectedNiCommunityId
  }) {
    let defaultDate = new Date().toISOString().slice(0, 10)
    this.preferNotDateOfBirth = preferNotDateOfBirth || true
    this.dateOfBirth = dateOfBirth || defaultDate
    
    this.selectedGenderId = selectedGenderId || 1
    this.selectedRaceId = selectedRaceId || 1
    this.sexualOrientationId = sexualOrientationId || 1
    this.selectedFaithId = selectedFaithId || 1
    this.selectedDisabledStatus = selectedDisabledStatus || 1

    this.genderSelfDescription = genderSelfDescription || ''
    this.raceSelfDescription = raceSelfDescription || ''
    this.orientationSelfDescription = orientationSelfDescription || ''
    this.faithSelfDescription = faithSelfDescription || ''

    this.preferNotNationality = preferNotNationality || true
    this.nationalitySelfDescription = nationalitySelfDescription || ''
    this.selectedNiCommunityId = selectedNiCommunityId || 1
  }
}

class Application {
  constructor({
    applicationKey,
    dateStarted,
    dateCompleted,

    architecturalRole,
    isSpeculative,
    userElectedArchitectural,
    
    completed,
    allowOfficeSelection,
    onlyOneOffice,
    offices,
    jobId,
    jobTitle,
    jobRoleTypeId,
    jobRoleType,

    // Applicant.
    title,
    firstName,
    surname,
    email,
    contactNumber,
    hasRightToWorkInUk,
    additionalRightToWorkInfo,
    startDate,
    weeksNotice,

    // Skills.
    partOneYear,
    partTwoYear,
    partThreeYear,
    skills,

    // Documents.
    coveringLetterCvPath,
    bestWorkPath,
    portfolioPath,
    websitePortfolioPath,

    // Details.
    reasonableAdjustments,
    heardAboutId,
    jobHeardAbout,
    
    equalOps
  }) {
    let defaultDate = '0001-01-01T00:00:00'
    this.applicationKey = applicationKey || '00000000-0000-0000-0000-000000000000'
    this.dateStarted = dateStarted || defaultDate
    this.dateCompleted = dateCompleted || defaultDate

    this.architecturalRole = architecturalRole || true
    this.isSpeculative = isSpeculative || true
    this.userElectedArchitectural = userElectedArchitectural || false

    this.completed = completed || false
    this.allowOfficeSelection = allowOfficeSelection || false
    this.onlyOneOffice = onlyOneOffice || false
    this.offices = offices || []
    this.jobId = jobId || '00000000-0000-0000-0000-000000000000'
    this.jobTitle = jobTitle || 'Speculative Application'
    this.jobRoleTypeId = jobRoleTypeId || 1
    this.jobRoleType = jobRoleType

    // Applicant.
    this.title = title || ''
    this.firstName = firstName || ''
    this.surname = surname || ''
    this.email = email || ''
    this.contactNumber = contactNumber || ''
    this.hasRightToWorkInUk = hasRightToWorkInUk || false
    this.additionalRightToWorkInfo = additionalRightToWorkInfo || ''
    this.startDate = startDate || defaultDate
    this.weeksNotice = weeksNotice || 0

    // Skills.
    this.partOneYear = partOneYear || 0
    this.partTwoYear = partTwoYear || 0
    this.partThreeYear = partThreeYear || 0
    this.skills = skills || []

    // Documents.
    this.coveringLetterCvPath = coveringLetterCvPath || ''
    this.bestWorkPath = bestWorkPath || ''
    this.portfolioPath = portfolioPath || ''
    this.websitePortfolioPath = websitePortfolioPath || ''

    // Details.
    this.reasonableAdjustments = reasonableAdjustments || ''
    this.heardAboutId = heardAboutId || 0
    this.jobHeardAbout = jobHeardAbout

    this.equalOps = equalOps ? new EqualOps(equalOps) : new EqualOps({ })
  }
}

export default Application